// removed by extract-text-webpack-plugin
module.exports = {"modal":"CwDialog-modal","flyoutTopLeft":"CwDialog-flyoutTopLeft","flyoutTopRight":"CwDialog-flyoutTopRight","flyoutBottomLeft":"CwDialog-flyoutBottomLeft","flyoutBottomRight":"CwDialog-flyoutBottomRight","wrap":"CwDialog-wrap","header":"CwDialog-header","subHeader":"CwDialog-subHeader","content":"CwDialog-content","buttons":"CwDialog-buttons","after":"CwDialog-after"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwdialog/CwDialog.scss
// module id = 364
// module chunks = 0